import React from 'react';
import { usePreLoaderContext } from '../../context/PreloaderContext';
import { OrbitProgress } from 'react-loading-indicators';

const PreLoader = () => {
  const { pathIndex, colors, preLoaderVisible } = usePreLoaderContext();

  //console.log(pathIndex);

  if (!preLoaderVisible) {
    return null; // veya istediğin başka bir şey
  }

  return (
    <div className="preloader">
      <div className="preloader-in shadow-sm">
      {/* <svg
              width="60"
              height="60"
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.8168 15.6516L12.3146 2.86904C11.9902 2.11635 11.1173 1.7688 10.3636 2.09211C9.61094 2.41642 9.26339 3.29034 9.5877 4.04303L13.6825 13.5592L8.39553 11.4507C7.63375 11.1466 6.76993 11.5184 6.46582 12.2802C6.16272 13.0419 6.53351 13.9048 7.29529 14.2089L15.8699 17.6268C16.1709 17.747 16.4862 17.7581 16.7792 17.6844C16.8671 17.6652 16.9539 17.6389 17.0398 17.6025C17.7925 17.2782 18.1401 16.4053 17.8168 15.6516Z"
                fill={pathIndex === false ? colors[1] : colors[0]}
              ></path>
              <path
                d="M22.3743 14.9454L27.5835 2.04058C27.8906 1.28082 27.5228 0.414975 26.7631 0.108848C26.0023 -0.199299 25.1375 0.169467 24.8303 0.929227L20.9527 10.5363L18.729 5.29582C18.4088 4.54112 17.5369 4.18851 16.7821 4.50879C16.0274 4.82906 15.6748 5.70096 15.9961 6.45567L19.6009 14.9524C19.7282 15.2505 19.9424 15.4829 20.2001 15.6385C20.2758 15.688 20.3556 15.7314 20.4425 15.7668C21.2023 16.0729 22.0681 15.7061 22.3743 14.9454Z"
                fill={pathIndex === false ? colors[0] : colors[1]}
              ></path>
              <path
                d="M26.1003 17.7328L38.997 12.5044C39.7568 12.1963 40.1225 11.3305 39.8144 10.5707C39.5062 9.81093 38.6414 9.44419 37.8816 9.75234L28.2806 13.6451L30.5002 8.40356C30.8205 7.64784 30.4679 6.77695 29.7122 6.45769C28.9575 6.13742 28.0866 6.49002 27.7663 7.24574L24.1665 15.7445C24.0403 16.0436 24.0231 16.3588 24.0898 16.6528C24.1079 16.7407 24.1312 16.8286 24.1665 16.9145C24.4747 17.6753 25.3405 18.041 26.1003 17.7328Z"
                fill={pathIndex === false ? colors[0] : colors[1]}
              ></path>
              <path
                d="M27.1965 22.1863L39.9922 27.6572C40.7459 27.9795 41.6188 27.6299 41.9411 26.8762C42.2634 26.1225 41.9138 25.2496 41.1591 24.9273L31.6338 20.8547L36.9178 18.7381C37.6796 18.433 38.0494 17.5682 37.7442 16.8084C37.4401 16.0466 36.5753 15.6768 35.8145 15.982L27.246 19.413C26.9449 19.5332 26.7085 19.7434 26.5469 19.998C26.4974 20.0727 26.4519 20.1515 26.4155 20.2374C26.0922 20.9911 26.4428 21.864 27.1965 22.1863Z"
                fill={pathIndex === false ? colors[0] : colors[1]}
              ></path>
              <path
                d="M24.2141 26.2195L29.7486 38.9879C30.0739 39.7406 30.9478 40.0861 31.7005 39.7598C32.4532 39.4345 32.7987 38.5596 32.4724 37.8079L28.3533 28.3018L33.6464 30.3972C34.4082 30.6993 35.271 30.3255 35.5731 29.5627C35.8742 28.8009 35.5014 27.9381 34.7386 27.636L26.1559 24.2393C25.8548 24.1201 25.5386 24.11 25.2466 24.1837C25.1597 24.2039 25.0718 24.2302 24.986 24.2676C24.2343 24.5929 23.8887 25.4668 24.2141 26.2195Z"
                fill={pathIndex === false ? colors[0] : colors[1]}
              ></path>
              <path
                d="M19.606 27.1177L14.1927 39.9376C13.8734 40.6933 14.228 41.5642 14.9828 41.8825C15.7385 42.2018 16.6094 41.8481 16.9286 41.0924L20.9578 31.549L23.0986 36.8238C23.4068 37.5836 24.2726 37.9493 25.0324 37.6412C25.7922 37.333 26.1579 36.4672 25.8497 35.7074L22.3793 27.1541C22.2571 26.854 22.0459 26.6186 21.7913 26.459C21.7165 26.4085 21.6367 26.364 21.5508 26.3276C20.7961 26.0084 19.9252 26.362 19.606 27.1177Z"
                fill={pathIndex === false ? colors[1] : colors[0]}
              ></path>
              <path
                d="M15.8678 24.017L3.04992 29.4344C2.2942 29.7536 1.94059 30.6245 2.25985 31.3792C2.57911 32.1349 3.45 32.4886 4.20471 32.1693L13.7472 28.1371L11.6053 33.41C11.2961 34.1697 11.6619 35.0366 12.4216 35.3447C13.1814 35.6539 14.0472 35.2881 14.3564 34.5284L17.8309 25.9771C17.9521 25.676 17.9663 25.3608 17.8945 25.0678C17.8743 24.9809 17.8501 24.893 17.8137 24.8071C17.4944 24.0514 16.6235 23.6978 15.8678 24.017Z"
                fill={pathIndex === false ? colors[1] : colors[0]}
              ></path>
              <path
                d="M14.9474 19.5161L2.04059 14.3129C1.27982 14.0068 0.414985 14.3745 0.107849 15.1353C-0.198278 15.8951 0.169478 16.7599 0.930248 17.067L10.5384 20.9406L5.29887 23.1663C4.54416 23.4866 4.19257 24.3585 4.51385 25.1132C4.83412 25.8679 5.70602 26.2195 6.46073 25.8992L14.9555 22.2894C15.2535 22.1621 15.4859 21.9479 15.6415 21.6903C15.69 21.6145 15.7344 21.5347 15.7688 21.4478C16.0759 20.688 15.7072 19.8222 14.9474 19.5161Z"
                fill={pathIndex === false ? colors[1] : colors[0]}
              ></path>
          </svg> */}
        <OrbitProgress
          variant="disc"
          color="#ff5b05"
          size="medium"
          text=""
          textColor=""
        />
      </div>
    </div>
  );
};

export default PreLoader;